import jwtDecode from 'jwt-decode'
import dayjs from 'dayjs'

export const isJwtTokenExpired = token => {
  const { iat } = jwtDecode(token)
  return dayjs().diff(dayjs(iat * 1000), 'days') > 7 // iat - issued at, in seconds. * 1000 - transforms to ms
}
